(function() {
  'use strict';

  if (window.__msmInit) return;
  window.__msmInit = true;

  function initMembershipPage() {
    var bar = document.querySelector('.msm-progress');
    if (bar) {
      window.addEventListener('scroll', function() {
        var scrolled = window.scrollY;
        var maxScroll = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = ((scrolled / maxScroll) * 100) + '%';
      }, { passive: true });
    }

    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('msm-visible');
        revealObs.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px 50px 0px' });

    document.querySelectorAll('[data-msm-reveal], .msm-benefit').forEach(function(el, i) {
      el.style.transitionDelay = (i % 4) * 80 + 'ms';
      revealObs.observe(el);
    });


    // Smooth-scroll CTAs (e.g. "Join the club" buttons at the end of sections)
    document.querySelectorAll('[data-msm-scroll]').forEach(function(el) {
      el.addEventListener('click', function(e) {
        var sel = el.getAttribute('data-msm-scroll') || '#msm-join';
        var target = document.querySelector(sel);
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.shopify-section-group-header-group, #shopify-section-header');
        var offset = header ? header.getBoundingClientRect().height : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset - 12;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      });
    });

    document.querySelectorAll('.msm-quarters__scroll').forEach(function(scroll) {
      var isDown = false, startX, scrollLeft;

      scroll.addEventListener('mousedown', function(e) {
        isDown = true;
        scroll.style.cursor = 'grabbing';
        startX = e.pageX - scroll.offsetLeft;
        scrollLeft = scroll.scrollLeft;
      });

      function stopDrag() {
        isDown = false;
        scroll.style.cursor = 'grab';
      }

      scroll.addEventListener('mouseleave', stopDrag);
      scroll.addEventListener('mouseup', stopDrag);
      scroll.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - scroll.offsetLeft;
        scroll.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });
    });

    document.querySelectorAll('.msm-btn').forEach(function(btn) {
      btn.addEventListener('mousemove', function(e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x * 0.15) + 'px, ' + (y * 0.25) + 'px)';
      });

      btn.addEventListener('mouseleave', function() {
        btn.style.transform = '';
      });
    });

    var heroImg = document.querySelector('.msm-hero__img');
    if (heroImg) {
      window.addEventListener('scroll', function() {
        var y = window.scrollY;
        if (y < window.innerHeight) {
          heroImg.style.transform = 'scale(' + (1.08 - y * 0.00008) + ') translateY(' + (y * 0.15) + 'px)';
        }
      }, { passive: true });
    }

    // --- Membership purchase form ---
    // Three subscription products (one per cadence) are merged into one picker.
    // window.msmPlanData[planKey] = { months, sizes: { sizeValue: {variantId, planId, price, compare, save} } }
    // A single size selector drives all plans; the chosen plan + size resolve to
    // the exact variant id + selling plan id we submit to /cart/add.
    var msmData = window.msmPlanData;
    if (msmData) {
      var idInput = document.querySelector('[data-msm-variant-id]');
      var sellingPlanInput = document.querySelector('[data-msm-selling-plan]');
      var sizeInputs = document.querySelectorAll('[data-msm-size]');
      var planInputs = document.querySelectorAll('[data-msm-plan]');
      var submitBtn = document.querySelector('[data-msm-submit]');

      // Gift elements (present only when the "Enable gift option" setting is on).
      var giftToggle = document.querySelector('[data-msm-gift-toggle]');
      var giftFields = document.querySelector('[data-msm-gift-fields]');
      var giftInputs = document.querySelectorAll('[data-msm-gift-input]');
      var giftEmail = document.querySelector('[data-msm-gift-email]');
      var giftError = document.querySelector('[data-msm-gift-error]');
      var sizeGroup = document.querySelector('.msm-variant-group');

      var isGifting = function() { return !!(giftToggle && giftToggle.checked); };

      var getSize = function() {
        var c = document.querySelector('[data-msm-size]:checked');
        return c ? c.value : null;
      };
      var getPlanKey = function() {
        var c = document.querySelector('[data-msm-plan]:checked');
        return c ? c.getAttribute('data-plan-key') : null;
      };
      // Falls back to the first available size if the chosen size isn't carried
      // by this particular product (keeps prices/cart from breaking).
      var entryFor = function(planKey, size) {
        var plan = planKey ? msmData[planKey] : null;
        if (!plan || !plan.sizes) return null;
        return plan.sizes[size] || plan.sizes[Object.keys(plan.sizes)[0]] || null;
      };
      var giftFor = function(planKey) {
        var plan = planKey ? msmData[planKey] : null;
        return plan && plan.gift ? plan.gift : null;
      };

      var refreshPrices = function() {
        var size = getSize();
        var gifting = isGifting();
        planInputs.forEach(function(planInput) {
          var key = planInput.getAttribute('data-plan-key');
          var plan = msmData[key];
          var wrap = planInput.closest('.msm-plan-option');
          if (!plan || !wrap) return;
          var entry = entryFor(key, size);
          var gift = giftFor(key);
          var priceEl = wrap.querySelector('[data-msm-price]');
          var saveEl = wrap.querySelector('[data-msm-save]');
          var sepEl = wrap.querySelector('.msm-plan-option__sep');
          var freqEl = wrap.querySelector('[data-msm-freq]');
          var ribbonEl = wrap.querySelector('[data-msm-ribbon]');

          if (gifting && gift) {
            if (priceEl) priceEl.innerHTML = gift.price;
            if (freqEl) freqEl.textContent = plan.months + '-month gift';
            if (saveEl) saveEl.hidden = true;
            if (sepEl) sepEl.hidden = true;
            if (ribbonEl) ribbonEl.hidden = true;
          } else {
            if (entry && priceEl) {
              priceEl.innerHTML = entry.price +
                (entry.compare && entry.compare !== entry.price ? '<s>' + entry.compare + '</s>' : '');
            }
            if (entry && saveEl) { saveEl.textContent = 'Save ' + entry.save + '%'; saveEl.hidden = (entry.save <= 0); }
            if (sepEl) sepEl.hidden = (!entry || entry.save <= 0);
            if (freqEl) freqEl.textContent = 'Billed every ' + plan.months + ' months';
            if (ribbonEl) {
              if (entry && entry.save > 0 && entry.saveYear) {
                ribbonEl.textContent = 'SAVE ' + entry.saveYear + '/YEAR';
                ribbonEl.hidden = false;
              } else {
                ribbonEl.hidden = true;
              }
            }
          }
        });
      };

      var refreshForm = function() {
        var key = getPlanKey();
        if (isGifting()) {
          var gift = giftFor(key);
          if (gift) {
            if (idInput) idInput.value = gift.variantId;
            if (sellingPlanInput) sellingPlanInput.value = '';
          }
          return;
        }
        var entry = entryFor(key, getSize());
        if (!entry) return;
        if (idInput) idInput.value = entry.variantId;
        if (sellingPlanInput) sellingPlanInput.value = entry.planId;
      };

      var setActiveCard = function() {
        planInputs.forEach(function(planInput) {
          var wrap = planInput.closest('.msm-plan-option');
          if (wrap) wrap.classList.toggle('msm-plan-option--active', planInput.checked);
        });
      };

      var validateGift = function() {
        if (!submitBtn) return;
        if (!isGifting()) { if (giftError) giftError.textContent = ''; submitBtn.disabled = false; return; }
        var valid = giftEmail && giftEmail.value.trim() !== '' && giftEmail.checkValidity();
        submitBtn.disabled = !valid;
        if (giftError) giftError.textContent = valid ? '' : 'Please enter a valid recipient email address';
      };

      var toggleGift = function() {
        var on = isGifting();
        if (giftFields) giftFields.hidden = !on;
        if (sizeGroup) sizeGroup.hidden = on; // gift products are single-variant
        giftInputs.forEach(function(el) {
          el.disabled = !on;
          if (!on) el.value = '';
        });
        if (giftEmail) giftEmail.required = on;
        if (on && giftInputs[0]) giftInputs[0].focus();
        refreshPrices();
        refreshForm();
        validateGift();
      };

      sizeInputs.forEach(function(inp) {
        inp.addEventListener('change', function() { refreshPrices(); refreshForm(); });
      });
      planInputs.forEach(function(planInput) {
        planInput.addEventListener('change', function() { setActiveCard(); refreshPrices(); refreshForm(); });
      });
      if (giftToggle) giftToggle.addEventListener('change', toggleGift);
      if (giftEmail) {
        giftEmail.addEventListener('input', validateGift);
        giftEmail.addEventListener('blur', validateGift);
      }

      setActiveCard();
      refreshPrices();
      refreshForm();
      if (giftToggle) toggleGift();
    }

    var qtyInput = document.querySelector('[data-msm-qty-input]');
    var qtyMinus = document.querySelector('[data-msm-qty-minus]');
    var qtyPlus = document.querySelector('[data-msm-qty-plus]');
    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10);
        qtyInput.value = val + 1;
      });
    }

    document.querySelectorAll('a[href^="#msm"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        var id = link.getAttribute('href').substring(1);
        var target = document.getElementById(id);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMembershipPage);
  } else {
    initMembershipPage();
  }
})();
